const UK_VAT_MULTIPLIER = 1.2;

function getUKRetailPrice(basePrice) {
  const parsedBasePrice = Number.parseInt(basePrice, 10);

  if (!Number.isFinite(parsedBasePrice) || parsedBasePrice < 0) {
    return 0;
  }

  return Math.round(parsedBasePrice * UK_VAT_MULTIPLIER);
}

function getUKRetailSubtotal(basePrice, quantity) {
  const parsedQuantity = Number.parseInt(quantity, 10);
  const safeQuantity = Number.isFinite(parsedQuantity) && parsedQuantity > 0 ? parsedQuantity : 0;

  return getUKRetailPrice(basePrice) * safeQuantity;
}

const PMUKRetailPricing = {
  UK_VAT_MULTIPLIER,
  getUKRetailPrice,
  getUKRetailSubtotal,
};

if (typeof window !== 'undefined') {
  window.PMUKRetailPricing = PMUKRetailPricing;
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = PMUKRetailPricing;
}
